import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Table, TimestampFilters } from "dyl-components";
import { Table as SemanticTable } from "semantic-ui-react";
import { getData, onToggleTimeUnit, useRangeCalendar } from "shared/CustomDateRange/customDateRange";
import SortActions from "pages/Groups/subcomponents/SortActions";

export default function CampaignRegistrationHeader({ onFilter }) {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const [areTimeUnitOptionsOpenForCreated, setTimeUnitOptionsOpenForCreated] = useState(false);
    const [areTimeUnitOptionsOpenForRegistered, setTimeUnitOptionsOpenForRegistered] = useState(false);

    const createdCalendar = useRangeCalendar(params, true, { start: "created_start", end: "created_end" });
    const registeredCalendar = useRangeCalendar(params, true, { start: "registered_start", end: "registered_end" });

    const createdOrder = params.get("order_by") === "created" && params.get("order") === "asc";
    const registeredOnOrder = params.get("order_by") === "registered" && params.get("order") === "asc";

    const handleSort = (field, currentOrder) => {
        const query = new URLSearchParams(params);
        const order = !currentOrder ? "asc" : "desc";
        query.set("order", order);
        query.set("order_by", field);
        const query_string = query.toString();
        navigate(`/settings/phone-management/tcr/campaign-registration${query_string ? `?${query_string}` : ""}`);
    };

    const renderTimestampFilter = (calendar, label, sortField, sortDirection, width, timeUnitState, setTimeUnitState) => (
        <SemanticTable.HeaderCell className={width === 2 ? "CampaignRegistrationTable__MediumFixedWidth" : "CampaignRegistrationTable__SmallFixedWidth"} width={width}>
            <span style={{ marginRight: 5 }}>{label}</span>

            <TimestampFilters
                timestamp={calendar.timestamp}
                onToggleTimeUnit={(timestamp) =>
                    onToggleTimeUnit(
                        timestamp,
                        calendar.setTimestamp,
                        params,
                        navigate,
                        "/settings/phone-management/tcr/campaign-registration",
                        calendar.keys
                    )
                }
                isCustomDateRangeOpen={calendar.isCustomDateRangeOpen}
                onOpenCustomDateRange={() => { calendar.setCustomDateRangeOpen(true); calendar.setDateRange("") }}
                onCloseCustomDateRange={() => calendar.setCustomDateRangeOpen(false)}
                areTimeUnitOptionsOpen={timeUnitState}
                onOpenTimeUnitOptions={() => {
                    setTimeUnitState(true);
                }}
                onCloseTimeUnitOptions={() => {
                    setTimeUnitState(false);
                }}

                dateRange={calendar.dateRange}
                onDateRangeChange={(_, { value }) => calendar.setDateRange(value)}
                getData={() =>
                    getData({
                        setCustomDateRangeOpen: calendar.setCustomDateRangeOpen,
                        dateRange: calendar.dateRange,
                        userAuthTimezone: calendar.userAuthTimezone,
                        params,
                        navigate,
                        url: "/settings/phone-management/tcr/campaign-registration",
                        keys: calendar.keys,
                    })
                }
            />

            <SortActions
                direction={sortDirection}
                onToggleSort={() => handleSort(sortField, sortDirection)}
            />
        </SemanticTable.HeaderCell>
    );

    return (
        <Table.Row>
            {/* Created */}
            {renderTimestampFilter(createdCalendar, "Created", "created", createdOrder, 2, areTimeUnitOptionsOpenForCreated, setTimeUnitOptionsOpenForCreated)}

            {/* Registered On */}
            {renderTimestampFilter(registeredCalendar, "Registered On", "registered", registeredOnOrder, 2, areTimeUnitOptionsOpenForRegistered, setTimeUnitOptionsOpenForRegistered)}

            {/* Auto Renewal On */}
            {/* {renderTimestampFilter(autoRenewalCalendar, "Auto Renewal On", "auto_renewal", autoRenewalOnOrder,2)} */}
            <SemanticTable.HeaderCell className="CampaignRegistrationTable__SmallFixedWidth" width={1}>
                Auto Renewal On
            </SemanticTable.HeaderCell>
            {/* Other static columns */}
            <SemanticTable.HeaderCell className="CampaignRegistrationTable__MediumFixedWidth" width={2}>
                Campaign Name
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell className="CampaignRegistrationTable__MediumFixedWidth" width={2}>
                Campaign ID
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell className="CampaignRegistrationTable__SmallFixedWidth" width={1}>
                Phone Numbers
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell className="CampaignRegistrationTable__SmallFixedWidth" width={4}>
                Approval Status
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell className="CampaignRegistrationTable__SmallFixedWidth" width={1}>
                TCR Status
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell className="CampaignRegistrationTable__SmallFixedWidth" width={1}>
                Actions
            </SemanticTable.HeaderCell>
        </Table.Row>
    );
}
